<div class="card">
    <p-treeTable [value]="activityList" [columns]="cols" [scrollable]="true" [tableStyle]="{ 'min-width': '50rem' }" styleClass="p-datatable-gridlines p-datatable-striped"
    [autoLayout]="true" selectionMode="single">
        <ng-template pTemplate="caption">
            <div class="text-xl font-bold">Activity Settings</div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
            <tr>
                @for (col of columns; track col.field) {
                <th [style.width]="col.field === 'name' ? '250px' : 'auto'">
                    {{ col.header }}
                </th>
                }
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
            <tr [ttRow]="rowNode" style="border-right: 1px solid var(--primary-color);" [ttSelectableRow]="rowNode">
                @for (col of columns; track col.field; let i = $index; let last = $last) {
                <td [style.width]="col.field ===  'name' ? '250px' : 'auto'">
                    <div class="flex align-items-center">
                        @if (i === 0) {
                        <p-treeTableToggler [rowNode]="rowNode" />
                        }
                        @switch (col.field) {
                        @case ('name') {
                        <span class="whitespace-nowrap overflow-hidden text-overflow-ellipsis">
                            {{ rowData[col.field] }}
                        </span>
                        }
                        @case ('color') {
                        <span class="flex align-items-center">
                            <div class="color-box" [ngStyle]="{ 'background-color': rowData[col.field] }">
                            </div>
                        </span>
                        }
                        @case ('action') {
                        @if (rowData.nodeType === 'activity') {
                        <p-button icon="pi pi-pencil" rounded="true" severity="success" (onClick)="onEdit(rowData)"
                            pTooltip="Edit" toolTipPosition="top" />
                        }
                        }
                        @default {
                        <span>{{ rowData[col.field] }}</span>
                        }
                        }
                    </div>
                </td>
                }

            </tr>
        </ng-template>
    </p-treeTable>
</div>


<!-- Add this at the bottom of your existing template -->
<p-dialog 
    [(visible)]="displayEditDialog" 
    [modal]="true" 
    [style]="{width: '450px'}" 
    header="Edit Activity" 
    [draggable]="false" 
    [resizable]="false"
    (onHide)="hideDialog()"
    [focusOnShow]="false">
    
    <form [formGroup]="activityForm" class="flex flex-column gap-3">
        <div class="field">
            <label for="name" class="font-bold"><strong>Name</strong><span style="color: red;">*</span></label>
            <input 
                id="name" 
                type="text" 
                pInputText 
                class="w-full" 
                formControlName="name">
            @if (activityForm.get('name')?.hasError('required') && activityForm.get('name')?.touched) {
                <small class="p-error">Name is required</small>
            }
        </div>

        <div class="field">
            <label for="description" class="font-bold"><strong>Description</strong><span style="color: red;">*</span></label>
            <textarea 
                id="description" 
                pInputTextarea 
                rows="3" 
                class="w-full" 
                formControlName="description">
            </textarea>
            @if (activityForm.get('description')?.hasError('required') && activityForm.get('description')?.touched) {
                <small class="p-error">Description is required</small>
            }
        </div>

        <div class="field">
            <label for="color" class="font-bold"><strong>Color</strong></label>
            <p-colorPicker 
                formControlName="color" 
                [inline]="false" 
                [style]="{'width': '100%'}"
                appendTo="body">
            </p-colorPicker>
            @if (activityForm.get('color')?.hasError('required') && activityForm.get('color')?.touched) {
                <small class="p-error">Color is required</small>
            }
        </div>
    </form>

    <ng-template pTemplate="footer">
        <div class="flex justify-content-end gap-2">
            <p-button 
                label="Cancel" 
                (onClick)="hideDialog()" 
                styleClass="p-button-text">
            </p-button>
            <p-button 
                label="Save" 
                (onClick)="onSubmit()" 
                [disabled]="!activityForm.valid">
            </p-button>
        </div>
    </ng-template>
</p-dialog>